<template>

  <mw-dialog size="mini_small" ref="dialog"  :title="$lang('选择用户')" :appendToBody="false" :footerButton="userFooterButton">


      <mw-tree :url="params.treeUrl || userTreeUrl" :treeData="params.treeData" :singleLeaf="true" :async="true" :expandedFirst="true" @loaded_tree="loadedTree"
               ref="userTree" :multiple="false" :search="false" :defaultParams="defaultParams" :aliasId="aliasId"></mw-tree>
    </mw-dialog>

</template>
<script>

    export default {
        props: {
          params: {
            type: Object
          }
        },
        data() {
            return {
              userTreeUrl: this.mwUrl('/api/process/getTransmitObject'),
              defaultParams:{},
              aliasId:'departmentId',
              userFooterButton: [
                {label: $lang('取消'), func: this.selectUserCancel,type: 'default'},
                {label: $lang('确定'), func: this.selectUserSure}
              ]
            }
        },

       mounted() {
         setTimeout(()=>{
           this.show();
         },200)
         this.init();
       },
       watch:{
          params(){
            this.init();
          }
       },
       methods:{
         setBtnLoading(loading,idx){
           this.userFooterButton[idx].loading=loading;
         },
         btnDebounce:_.debounce(function(callback){
           let me=this;
           if(callback){
             callback();
           }
         }, 1000, {
           'leading': true,
           'trailing': false
         }),
       //选择用户
        selectUserSure() {
          var me = this;
          me.btnDebounce(function(){
            me.setBtnLoading(true, 1);
            let data = me.mwRef('userTree').getSelected();
            if(data.length < 1){
              me.mwMsg('info',$lang('请选择用户！'));
              me.setBtnLoading(false, 1);
              return;
            }
            let params = {};
            params.receiver={
              id: data.id,
              name: data.name,
              deptId:data.parentId
            }
            me.params.func(params);
            me.selectUserCancel();
            me.setBtnLoading(false, 1);
          });
        },

        selectUserCancel() {
          this.mwRef('dialog').hide();
        },
        init(){
          this.defaultParams={taskId:this.params.taskId};
        },
        resetForm(){
          var me=this;

        },
        formActionComplete(){
          let me=this;
          if(me.params.func){
            me.params.func()
          }
          this.resetForm();
        },
        loadedTree:function(inst){
          let children = inst.get_node("#").children;
          if(children && children.length > 0){
              let firstNode = inst.get_node(children[0]);
              if(firstNode && firstNode.original && firstNode.original.flag!="1"){
                inst.open_all();
              }
          }
        },
        show(){
          this.mwRef('dialog').show();
        },
        close(){
          this.resetForm();
          this.mwRef('dialog').hide();
        }
      }
    }
</script>



// WEBPACK FOOTER //
// src/common/components/public-dialog/transmit.vue